module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step",
    class: {
      'step_end': _vm.isEnd
    }
  }, [_c('MentoringNumberIcon', {
    attrs: {
      "number": _vm.number
    }
  }), (_vm.text.length) ? _c('p', {
    staticClass: "step__text",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "step__arrow",
    class: {
      'step__arrow_hide': _vm.isEnd
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b54b0ff","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/process/components/number/MentoringNumber.vue
// module id = 2312868586cfd65a3cdd
// module chunks = 89